<!--
采用video.js播放器
参考：
https://github.com/ShmilyLin/video.js.zh-cn
https://docs.videojs.com/player#
-->

<!-- 行业应用 -->
<template>
  <div class="ApplicationLive">
    <!-- 头部 -->
    <gat-head class="ApplicationLive-head"></gat-head>
    <div class="ApplicationLive-content">
      <div class="backButton el-icon-arrow-left" @click="onBack">返回</div>
      <div class="ApplicationLive-bg">
        <img src="../../assets/images/liveBroadcast-bg.png" alt="" />
      </div>
      <div class="ApplicationLive-Interface">
        <div class="ApplicationLive-video">
          <!-- <video-player
            class="video-player vjs-custom-skin video-media"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player> -->
          <video
            id="myVideo"
            class="video-js vjs-custom-skin video-media  vjs-big-play-centered vjs-fluid"
            ref="videoPlayer"
            width="100%"
            height="100%"
          >
<!-- <source type="video/mp4" :src="videoUrl" />-->
          </video>
        </div>
        <div class="ApplicationLive-Introduction">
          <div class="Introduction-title">{{ videoObj.videoName }}</div>
          <div class="Introduction-text">
            简介：{{ videoObj.videoDescribe }}
          </div>
        </div>
        <div class="ApplicationLive-recommend">
          <div class="recommend-head">
            <span class="recommend-head-left">热门推荐</span>
            <span class="recommend-head-right" @click="onMore">
              更多
              <i
                :class="[
                  switchShow ? 'el-icon-arrow-down' : 'el-icon-arrow-right',
                ]"
              ></i>
            </span>
          </div>
          <div class="recommend-content">
            <div
              class="recommend-content-list"
              v-for="(item, index) in tradeVideoResList"
              :key="index"
              @click="onrecommend(item)"
            >
              <img :src="item.imgUrl" alt="" />
              <p>{{ item.videoName }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APPLICATION from '@/axios/Application/Application.js'
export default {
  name: 'ApplicationLive',
  components: {},
  data() {
    return {
      videoUrl: '',
      playbackStatus: false, // true-为播放完毕
      gtaVideo: null, //video.js 实例化对象
      videoUrlData: {
        videoUrl: ''
      },
      videoOptions: {
        //video.js参数配置
        loop : true, // 循环播放
        controls: true, // true：视频操作区显示
        autoplay: true, //自动播放属性,muted:静音播放
        preload: 'auto', //建议浏览器是否应在<video>加载元素后立即开始下载视频数据
        // width: "800px", //设置视频播放器的显示宽度（以像素为单位）
        // height: "400px", //设置视频播放器的显示高度（以像素为单位）
        language: 'zh-CN', // 设置语言
        controlBar: {
          playToggle: true,
          /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            {
              // 播放按钮
              name: 'playToggle',
            },
            {
              // 当前播放时间
              name: 'currentTimeDisplay',
            },
            {
              // 总时间
              name: 'durationDisplay',
            },
            {
              // 播放进度条
              name: 'progressControl',
            },
            {
              // 倍数播放
              name: 'playbackRateMenuButton',
              playbackRates: [0.5, 1, 1.5, 2],
            },
            {
              // 音量控制
              name: 'volumePanel',
              inline: false, // 不使用水平方式
            },
            {
              // 全屏
              name: 'FullscreenToggle',
            },{
              // 按下
              text: 'press',
            },
          ],
        },
        isFullscreen: true,
      },
      // 视频播放
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '',
            src: 'http://vjs.zencdn.net/v/oceans.mp4', //url地址
          },
        ],
        poster: '', //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      videoObj: {},
      tradeVideoResListAll: [],
      tradeVideoResList: [],
      switchShow: false,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTradeVideoByVideoId()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initVideo() //初始化
  },
  methods: {
    initVideo() {
      //页面dom元素渲染完毕，执行回调里面的方法
      let self = this
      this.$nextTick(() => {
        this.gtaVideo = this.$video(
          document.getElementById('myVideo'),
          this.videoOptions
        )

        //监听window 双击事件
        window.addEventListener('dblclick', function() {
          if (self.gtaVideo.isFullscreen()) {
            self.exitFullscreenHandler()
          } else {
            self.fullScreenHandler()
          }
        })

        // self.fullScreenHandler()
        // 钩子：监听播放
        this.gtaVideo.on('play', function() {
          self.playbackStatus = false
        })
        // 钩子：监听结束
        this.gtaVideo.on('ended', function() {
          self.playbackStatus = true
          //退出全屏
          if (self.gtaVideo.isFullscreen()) {
            self.exitFullscreenHandler()
          }
        })
        // 钩子：监听隐藏
        this.gtaVideo.on('hide', function() {
          self.gtaVideo.dispose()
        })
      })
    },
    // 全屏
    fullScreenHandler() {
      this.gtaVideo.requestFullscreen()
    },
    // 退出全屏
    exitFullscreenHandler() {
      this.gtaVideo.exitFullscreen()
    },
    // 播放
    play() {
      this.gtaVideo.play()
    },
    // 暂停
    pause() {
      this.gtaVideo.pause()
    },
    getTradeVideoByVideoId(Id) {
      let videoId = Id || this.$route.query.videoId
      let data = {
        videoId: videoId,
      }
      APPLICATION.getTradeVideoByVideoId(data).then((result) => {
        if (result.isSuccess) {
          this.videoObj = result.data
          this.playerOptions.sources[0].src = this.videoObj.videoUrl
          this.videoUrl = result.data.videoUrl
          this.gtaVideo.src(result.data.videoUrl);
          this.gtaVideo.load(result.data.videoUrl);
          this.tradeVideoResListAll = result.data.tradeVideoResList
          if (result.data && result.data.tradeVideoResList.length > 0 && this.switchShow) {
            this.tradeVideoResList = result.data.tradeVideoResList
          } else {
            this.tradeVideoResList = result.data.tradeVideoResList.slice(0, 4)
          }
        }
      })
    },
    onMore() {
      this.switchShow = !this.switchShow
      this.switchShow === true
        ? (this.tradeVideoResList = this.tradeVideoResListAll)
        : (this.tradeVideoResList = this.tradeVideoResListAll.slice(0, 4))
    },
    onrecommend(val) {
      this.videoObj = val
      this.videoUrl ="";
      this.getTradeVideoByVideoId(val.videoId)
    },
    onBack() {
      this.$router.back()
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {

  }, //生命周期 - 销毁之前
  destroyed() {
        this.gtaVideo.dispose()
  }, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.ApplicationLive {
  width: 100%;
  min-height: 100%;
  background-color: #f2f5fc;
  background-size: cover;
  background-position: center;
  color: $font_color_1st;
  padding-top: 80px;
  .ApplicationLive-content {
    position: relative;

    // .video-js .my-image {
    //   width: 40px;
    //   background: url("../../assets/images/icon_watch.png") center center no-repeat;
    // }

    .backButton {
      position: absolute;
      top: 20px;
      left: 30px;
      font-size: 18px;
      // cursor: default;
      cursor: pointer;
    }
    .ApplicationLive-bg {
      img {
        width: 100%;
        height: 500px;
      }
    }
    .ApplicationLive-Interface {
      width: 1200px;
      height: 100%;
      margin: auto;
      // margin-top: -420px;
      margin-top: calc(10vh - 520px);
      // position: absolute;
      // top: 10vh;
      // left: 50%;
      // margin-left: -600px;
      .ApplicationLive-video {
        width: 1200px;
        // height: 675px;
        height: 72vh;
        border-radius: 20px;
        overflow: hidden;

        .video-media {
          height: 72.2vh;
        }
        ::v-deep.vjs-fluid {
          padding-top: 0;
        }
        ::v-deep.vjs-custom-skin > .video-js {
          height: 72.2vh;
          .vjs-big-play-button {
            height: 35vh;
          }
        }
        ::v-deep.vjs-custom-skin > .video-js .vjs-big-play-button {
          top: 35vh;
        }
        // 全屏
        ::v-deep.vjs-fullscreen {
          height: 100vh;
          // ::v-deep.vjs-custom-skin > .video-js .vjs-big-play-button {
          //   top: 50vh;
          // }
        }

        ::v-deep.video-js .vjs-progress-control .vjs-progress-holder {
          font-size: 1.6666666667em;
        }

        ::v-deep.vjs-slider-vertical .vjs-volume-level:before {
          left: -0.46em;
        }
      }
      .ApplicationLive-Introduction {
        margin: 35px 0 92px;
        .Introduction-title {
          height: 25px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          // line-height: 20px;
          margin-bottom: 22px;
        }
        .Introduction-text {
          // height: 60px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          color: #333333;
          // line-height: 22px;
        }
      }
      .ApplicationLive-recommend {
        .recommend-head {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          .recommend-head-left {
            height: 18px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            color: #333333;
            line-height: 18px;
            float: left;
            border-left: 4px solid #4c88ff;
            padding-left: 11px;
          }
          .recommend-head-right {
            height: 12px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #333333;
            line-height: 20px;
            &:hover {
              cursor: pointer;
            }
          }
        }
        .recommend-content {
          height: 100%;
          display: flex;
          // justify-content: space-between;
          flex-wrap: wrap;
          padding-bottom: 112px;
          .recommend-content-list {
            width: 282px;
            height: 260px;
            background: #ffffff;
            border: 1px solid #dfe6f4;
            box-shadow: 0px 4px 10px 0px rgba(109, 113, 171, 0.1);
            border-radius: 4px;
            margin-bottom: 20px;
            margin-right: 24px;
            cursor: pointer;
            img {
              width: 100%;
              height: 180px;
            }
            p {
              height: 21px;
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #333333;
              // line-height: 28px;
              margin: 20px 0 0 15px;
            }
          }
          .recommend-content-list:nth-child(4n + 0) {
            margin-right: 0px;
          }
        }
      }
    }
  }
}
</style>
